'use strict';

angular.module('shopspace.admin', [
  'pascalprecht.translate',
  'ngAnimate',
  'ngCookies',
  'ngSanitize',
  'restangular',
  'ui.router',
  'flow',
  'ui.checkbox',
  'jcs-autoValidate',
  'angular-growl',
  'ui.bootstrap',
  'ui.bootstrap.datetimepicker',
  'angular-loading-bar',
  'ngTagsInput',
  'dialogs.main',
  'xenon',
  'cgBusy',
  'monospaced.elastic',
  'ngMap',
  'ui.bootstrap.popover',
  'quill.editor',

  /*'ui-router-logger',*/

  // Core modules
  'shopspace.config',
  'shopspace.directives',
  'shopspace.import',

  // Feature aggregates (replaces 66 individual modules)
  'shopspace.orders.all',
  'shopspace.wms.all',
  'shopspace.crm.all',
  'shopspace.catalog.all',
  'shopspace.marketing.all',
  'shopspace.location.all',
  'shopspace.management.all',
  'shopspace.cms.all',

  // Report modules
  'shopspace.reportViewer',
  'shopspace.report'
])
  .config(
    function ($stateProvider, $urlRouterProvider, $locationProvider, RestangularProvider, cfpLoadingBarProvider, growlProvider, $translateProvider,
      flowFactoryProvider) {

      $locationProvider.html5Mode(true).hashPrefix('!');

      growlProvider.globalTimeToLive({success: 2000, error: 3000, warning: 3000, info: 4000});

      $stateProvider
        .state('app', {
          url: '/app',
          template: '<div ui-view></div>',
          abstract: true
        });

      RestangularProvider.setBaseUrl('/api');
      RestangularProvider.setDefaultHttpFields({
        withCredentials: true
      });

      RestangularProvider.addResponseInterceptor(function (data, operation,what) {
        let extractedData;
        // .. to look for getList operations
        if (((operation === 'getList' || (operation === 'post' && what === '_search'))
          && !angular.isArray(data))) {
          // .. and handle the data and meta data
          extractedData = data.content ? data.content : [];
          extractedData.meta = {
            pageNumber: data.pageNumber,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages
          };
        } else {
          extractedData = data;
        }
        return extractedData;
      });

      RestangularProvider.setResponseExtractor(function (response) {
        let newResponse = response;
        if (response) {
          if (angular.isObject(response)) {
            newResponse.originalElement = angular.copy(response);
          }
        }
        return newResponse;
      });

      flowFactoryProvider.defaults = {
        target: '/api/upload',
        testChunks: false,
        chunkSize: 20000000,
        permanentErrors: [404, 500, 501],
        simultaneousUploads: 1,
        allowDuplicateUploads: false
      };

      $translateProvider.translations('pl', {
        DIALOGS_ERROR: 'Błąd',
        DIALOGS_ERROR_MSG: 'Wystąpił nieznany błąd.',
        DIALOGS_CLOSE: 'Zamknij',
        DIALOGS_PLEASE_WAIT: 'Proszę czekać',
        DIALOGS_PLEASE_WAIT_ELIPS: 'Proszę czekać...',
        DIALOGS_PLEASE_WAIT_MSG: 'Proszę czekać na wykonanie operacji.',
        DIALOGS_PERCENT_COMPLETE: '%',
        DIALOGS_NOTIFICATION: 'Informacja',
        DIALOGS_NOTIFICATION_MSG: 'Nieznana informacja.',
        DIALOGS_CONFIRMATION: 'Potwierdzenie',
        DIALOGS_CONFIRMATION_MSG: 'Potwierdzenie wymagane.',
        DIALOGS_OK: 'OK',
        DIALOGS_YES: 'Tak',
        DIALOGS_NO: 'Nie'
      });

      $translateProvider.preferredLanguage('pl');

      $urlRouterProvider.otherwise('/app/orders/order');
    })
  .run(function ($rootScope, $state, $stateParams, Restangular, $window, defaultErrorMessageResolver, validator, emptyModifier, datetimePickerModifier,
    customMessageModifier, dialogs, appConfig, $http, menuVph, permissionService, $sce, $timeout) {

    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    $rootScope.layoutOptions = {
      horizontalMenu: {
        minimal: true,
        isFixed: true
      }
    };
    $rootScope.appConfig = appConfig;

    $rootScope.safeHtml = function (html) {
      return $sce.trustAsHtml(html);
    };

    Restangular.setErrorInterceptor(function (response) {
      if (response.status === 401) {
        $window.location.href = '/login.html';
        return false; // error handled
      }
      if (response.status === 403) {
        dialogs.error(undefined, 'Nie masz wystarczających uprawnień do wykonania tej operacji!');
        return false; // error handled
      }
      if (response.status === 409) {
        dialogs.error(undefined, 'Dane zostały zmodyfikowane przez kogoś innego, odśwież widok i spróbuj ponownie.');
      }
      if (response.status === 500) {
        let errorDetails = response.data ? String(response.data).replace(/</g, '&lt;').replace(/>/g, '&gt;') : 'Brak szczegółów';
        dialogs.error('Wewnętrzny błąd serwera', 'Skontaktuj się z administratorem. Szczegóły: ' + errorDetails);
      }

      return true; // error not handled
    });

    defaultErrorMessageResolver.getErrorMessages().then(function (errorMessages) {
      errorMessages.required = 'Pole wymagane';
      errorMessages.editable = 'Wartość musi być wybrana z pola podpowiedzi';
      errorMessages.pattern = 'Nieodpowiedni format';
      errorMessages.unique = 'Wartość musi być unikalna, a ta istnieje już w bazie';
      errorMessages.minlength = 'Minimalna długość to {0} znaków';
      errorMessages.maxlength = 'Maksymalna długość to {0} znaków';
      errorMessages.max = 'Maksymalna wartość to {0}';
      errorMessages.min = 'Minimalna wartość to {0}';
      errorMessages.esmaboOrdersTo = 'Wartość musi być większa niż Zamówienia od';
      errorMessages['invalid-number'] = 'Nieprawidłowa wartość liczbowa';
    });

    validator.setValidElementStyling(false);
    validator.registerDomModifier(emptyModifier.key, emptyModifier);
    validator.registerDomModifier(datetimePickerModifier.key, datetimePickerModifier);
    validator.registerDomModifier(customMessageModifier.key, customMessageModifier);

    $rootScope.logout = function () {
      $http.post('/api/auth/logout').finally(function () {
        window.location = '/login.html';
      });
    };

    permissionService.user().then(function () {
      angular.forEach(menuVph, function (val) {
        permissionService.hasActionPermission(val.permissionType, 'VIEW').then(function (res) {
          val.vph.show = res;
          if (val.vph.parent && res) {
            val.vph.parent.show = res;
          }
        });
      });
    });

    $rootScope.scrollToFixed = {
      marginTop: function () {
        let detailsEl = document.getElementById('details');
        let detailsHeight = detailsEl ? detailsEl.offsetHeight : 0;
        let marginTop = window.innerHeight - detailsHeight - 20;
        if (marginTop >= 0) {
          return 20;
        }
        return marginTop;
      }
    };

    // Assigned to variable to satisfy eslint; app-level listener lives for app lifetime
    let _unsubscribeStateChange = $rootScope.$on('$stateChangeSuccess', function () {
      $timeout(function () {
        window.scrollTo(0, 0);
      });
    });
    void _unsubscribeStateChange;

    function parseClipboard($event, text, wild, options, tagList) {
      if (/\r|\n/.exec(text)) {
        text = text.replace(/(\r\n|\r|\n)/g, (wild ? '*' : '') + '\n').replace(/\n$/, '');
      }
      if (wild && !text.endsWith('*')) {
        text += '*';
      }
      addTags(text, options, tagList);
    }

    function addTags(data, options, tagList) {

      let tags = data.split(options.pasteSplitPattern);

      tags.forEach(function (tag) {
        tagList.addText(tag);
      });
    }

    $rootScope.pasteNgTags = function ($event, options, tagList) {
      if (options.addOnPaste) {
        let clipboardData = $event.originalEvent.clipboardData || window.clipboardData;
        let text = clipboardData.getData('text/plain');
        $event.stopPropagation();
        $event.preventDefault();

        if (String(options.pasteSplitPattern) === String(/\n/)) {
          dialogs.confirm('', 'Wyszukiwanie z dopełnieniem?').result.then(
            function () {
              parseClipboard($event, text, true, options, tagList);
            },
            function () {
              parseClipboard($event, text, false, options, tagList);
            });
        } else {
          addTags(text, options, tagList);
        }
      }
    };
  })
  .factory('permissionService', function ($q, Restangular, $rootScope) {

    let isAdmin = false;
    let user;

    let userPromise = Restangular.one('users', 'me').get().then(function (resUser) {
      user = resUser;
      isAdmin = _.includes(user.allRolesNames, 'ADMIN');
      $rootScope.user = resUser;
      return user;
    }).catch(function (error) {
      console.error('Failed to fetch current user:', error);
      // Redirect to login page if user fetch fails
      if (error.status === 401 || error.status === 403) {
        window.location = '/login.html';
      }
      return $q.reject(error);
    });

    let hasActionPermission = function (type, permission) {

      if (isAdmin) {
        return true;
      }
      if (angular.isUndefined(user.allActionPermissions) || angular.isUndefined(user.allActionPermissions[type])) {
        return false;
      }
      let val = _.includes(user.allActionPermissions[type], permission);
      if (!val && permission === 'VIEW') {
        val = _.includes(user.allActionPermissions[type], 'READ_ALL');
      }
      return val;
    };

    let getObjectPermissions = function (type, objectId) {

      let u = hasActionPermission(type, 'UPDATE_ALL');
      let d = hasActionPermission(type, 'DELETE_ALL');
      let p = hasActionPermission(type, 'PERMISSION_ALL');

      return $q(function (resolve) {
        $q.all([u, d, p]).then(function (res) {
          let objectPerm = {
            'UPDATE': res[0],
            'DELETE': res[1],
            'PERMISSION': [2]
          };
          if (!objectPerm.UPDATE || !objectPerm.DELETE || !objectPerm.PERMISSION) {
            Restangular.one('permissions', objectId).customGET('my-permissions').then(function (perm) {
              objectPerm.UPDATE = perm.UPDATE || objectPerm.UPDATE;
              objectPerm.DELETE = perm.DELETE || objectPerm.DELETE;
              objectPerm.PERMISSION = perm.PERMISSION || objectPerm.PERMISSION;
              resolve(objectPerm);
            });
          } else {
            resolve(objectPerm);
          }
        });
      });
    };

    let getUser = function () {
      if (angular.isDefined(user)) {
        return $q.when(user);
      } else {
        return userPromise;
      }
    };

    return {
      user: getUser,
      hasRole: function (role) {
        if (angular.isDefined(user)) {
          return $q.when(isAdmin || _.includes(user.allRolesNames, role));
        } else {
          return $q(function (resolve) {
            userPromise.then(function () {
              resolve(isAdmin || _.includes(user.allRolesNames, role));
            });
          });
        }
      },
      hasActionPermission: function (type, permission) {

        if (angular.isDefined(user)) {
          return $q.when(hasActionPermission(type, permission));
        } else {
          return $q(function (resolve) {
            userPromise.then(function () {
              resolve(hasActionPermission(type, permission));
            });
          });
        }
      },
      getObjectPermissions: function (type, objectId) {

        if (angular.isDefined(user)) {
          return getObjectPermissions(type, objectId);
        } else {
          return $q(function (resolve) {
            userPromise.then(function () {
              getObjectPermissions(type, objectId).then(function (res) {
                resolve(res);
              });
            });
          });
        }
      }
    };
  })
  .controller('BusyController', function ($scope, $q, busyService) {

    let vm = this;
    let resolveBusyPromise;
    let unwatchMessage;

    busyService.bindListener({
      show: function (message) {
        // Deregister previous watcher to prevent memory leak
        if (unwatchMessage) {
          unwatchMessage();
          unwatchMessage = null;
        }

        if (angular.isObject(message)) {
          vm.messageObject = message;
          unwatchMessage = $scope.$watch(function () {
            return vm.messageObject ? vm.messageObject.text : undefined;
          }, function (newValue) {
            vm.message = newValue;
          });
          vm.message = vm.messageObject ? vm.messageObject.text : undefined;
        } else {
          vm.message = message ? message : 'Proszę czekać...';
        }
        vm.busyPromise = $q(function (resolve) {
          resolveBusyPromise = resolve;
        });

      },
      hide: function () {
        if (resolveBusyPromise) {
          resolveBusyPromise();
          resolveBusyPromise = null;
        }
        // Clean up watcher immediately when hiding
        if (unwatchMessage) {
          unwatchMessage();
          unwatchMessage = null;
        }
      }
    });

    // Cleanup on controller destroy
    $scope.$on('$destroy', function () {
      if (unwatchMessage) {
        unwatchMessage();
        unwatchMessage = null;
      }
    });
  })
  .factory('busyService', function () {
    let listener;
    return {
      bindListener: function (l) {
        listener = l;
      },
      show: function (message) {
        if (!listener) {
          throw 'No listener';
        }
        listener.show(message);
      },
      hide: function () {
        listener.hide();
      }
    };
  })
  .factory('emptyModifier', function () {
    return {
      makeValid: function () {
      },
      makeInvalid: function () {
      },
      makeDefault: function () {
      },
      key: 'emptyModifier'
    };
  })
  .factory('datetimePickerModifier', function () {
    let findFormGroup = function (elem) {
      let founded = elem;
      while (!founded.hasClass('form-group')) {
        founded = founded.parent();
        if (!founded || founded.length === 0) {
          return null;
        }
      }
      return founded;
    };
    return {
      makeValid: function () {
      },
      makeInvalid: function (el, errorMsg) {
        let helpTextEl = angular.element('<span class="help-block has-error error-msg" style="position: absolute;top: 80px;left: 170px">' + errorMsg +
          '</span>');
        let group = findFormGroup(el);
        if (!group || group.length === 0) {
          console.error('Not form group found');
          return;
        }
        let last = angular.element(_.last(group.children()));
        if (!last.hasClass('error-msg')) {
          last.after(helpTextEl);
          group.addClass('has-error');
        }
      },
      makeDefault: function (el) {
        let group = findFormGroup(el);
        if (!group || group.length === 0) {
          console.error('Not form group found');
          return;
        }
        let message = angular.element(_.last(group.children()));
        if (message.hasClass('error-msg')) {
          group.removeClass('has-error');
          message.remove();
        }
      },
      key: 'datetimePickerModifier'
    };
  })
  .factory('customMessageModifier', function () {
    let findFormGroup = function (elem) {
      let founded = elem;
      while (!founded.hasClass('form-group')) {
        founded = founded.parent();
        if (!founded || founded.length === 0) {
          return null;
        }
      }
      return founded;
    };
    return {
      makeValid: function () {
      },
      makeInvalid: function (el, errorMsg) {
        let group = findFormGroup(el);
        if (!group || group.length === 0) {
          console.error('Not form group found');
          return;
        }
        group.addClass('has-error');
        let hits = group.find('span');
        angular.forEach(hits, function (item) {
          let e = angular.element(item);
          if (e.hasClass('error-msg')) {
            e.text(errorMsg);
            e.removeClass('hidden');
          }
        });
      },
      makeDefault: function (el) {
        let group = findFormGroup(el);
        if (!group || group.length === 0) {
          console.error('Not form group found');
          return;
        }
        group.removeClass('has-error');
        let hits = group.find('span');
        angular.forEach(hits, function (item) {
          let e = angular.element(item);
          if (e.hasClass('error-msg')) {
            e.addClass('hidden');
          }
        });
      },
      key: 'customMessageModifier'
    };
  })
  // Generic resolver factory to eliminate code duplication
  .factory('createResolver', function (Restangular) {
    return function (endpoint, idsProperty, entitiesProperty) {
      return {
        resolve: function (item) {
          if (item[idsProperty]) {
            let ids = angular.isArray(item[idsProperty]) ? item[idsProperty] : [item[idsProperty]];

            if (ids.length === 1) {
              Restangular.one(endpoint, ids[0]).get().then(function (entity) {
                item[entitiesProperty] = [entity];
              });
            } else {
              Restangular.several(endpoint, ids).getList().then(function (entities) {
                item[entitiesProperty] = entities;
              });
            }
          }
        },
        toIds: function (item) {
          if (item[entitiesProperty]) {
            let ids = [];
            angular.forEach(item[entitiesProperty], function (entity) {
              ids.push(entity.id);
            });
            item[idsProperty] = ids;
            delete item[entitiesProperty];
          }
        }
      };
    };
  })
  .factory('viewsResolver', function (createResolver) {
    return createResolver('views', 'viewsIds', 'views');
  })
  .factory('storesResolver', function (createResolver) {
    return createResolver('stores', 'storesIds', 'stores');
  })
  .factory('branchesResolver', function (createResolver) {
    return createResolver('branches', 'branchesIds', 'branches');
  })
  .factory('criteriaResolver', function (createResolver) {
    return createResolver('criteria', 'criteriaIds', 'criteria');
  })
  .factory('deliveryResolver', function (createResolver) {
    return createResolver('deliveries', 'deliveriesIds', 'deliveries');
  })
  .factory('paymentResolver', function (createResolver) {
    return createResolver('payments', 'paymentsIds', 'payments');
  })
  .directive('form', function ($timeout) {
    return {
      require: 'form',
      restrict: 'E',
      link: function ($scope, $el, $attr, form) {
        form.manualSubmit = function () {
          $timeout(function () {
            $el.triggerHandler('submit');
          }, 0, false);
        };
      }
    };
  }).factory('RecursionHelper', ['$compile', function ($compile) {
    return {
    /**
     * Manually compiles the element, fixing the recursion loop.
     * @param element
     * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
     * @returns An object containing the linking functions.
     */
      compile: function (element, link) {
      // Normalize the link parameter
        if (angular.isFunction(link)) {
          link = {post: link};
        }

        // Break the recursion loop by removing the contents
        let contents = element.contents().remove();
        let compiledContents;
        return {
          pre: (link && link.pre) ? link.pre : null,
          /**
         * Compiles and re-adds the contents
         */
          post: function (scope, element) {
          // Compile the contents
            if (!compiledContents) {
              compiledContents = $compile(contents);
            }
            // Re-add the compiled contents to the element
            compiledContents(scope, function (clone) {
              element.append(clone);
            });

            // Call the post-linking function, if any
            if (link && link.post) {
              link.post.apply(null, arguments);
            }
          }
        };
      }
    };
  }]);
